import styled from 'styled-components';
import { breakpoints, css } from '../../styles/theme';
import PromoCodeTemplate from './PromoCodeTemplate';
import { rem } from 'polished';

export const PromoCodeStyled = styled(PromoCodeTemplate)`
    .promoCodeWrapper {
        display: flex;
        flex-direction: column;

        @media (min-width: ${breakpoints.sm}px) {
            justify-content: space-between;
            flex-direction: unset;
        }
    }
    
    ${({ noPadding }) =>
        !noPadding &&
        css`
            padding: ${rem(25)} ${rem(15)};
        `}

    .promoCode {
        &__title {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            text-transform: uppercase;
            text-align: center;

            @media (min-width: ${breakpoints.sm}px) {
                text-align: left;
            }
        }

        &__input_container {
            position: relative;
            align-self: stretch;

            @media (min-width: ${breakpoints.sm}px) {
                width: 40%;
                height: 100%;
            }
        }

        &__input_label_success {
            padding: ${rem(10)};
            display: flex;
            justify-content: center;
            border-radius: ${rem(3)};
            align-items: center;

            &::after {
                display: inline-block;
                content: '';
                width: 0;
                height: 0;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translate(-50%, 100%);
            }

            svg {
                g {
                    fill: ${({ theme }) => theme.colors.primaryBlack};
                }
                cursor: pointer;
            }
        }

        &__input_label_error {
            position: relative;
            left: 0;
            bottom: 0;
            display: block;
            font-size: ${({ theme }) => theme.fontSizes.textTiny};
            color: ${({ theme }) => theme.colors.danger};

            svg {
                margin-right: ${rem(10)};
                g {
                    path {
                        fill: ${({ theme }) => theme.colors.primaryBlack};
                    }
                }
            }
        }

        &__input {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            width: 100%;
            height: ${rem(50)};
            padding: ${rem(5)} ${rem(10)};
          
            &_error {
                border: 1px solid ${({ theme }) => theme.colors.danger};
            }

            @media (min-width: ${breakpoints.sm}px) {
                margin-bottom: 0;
            }
        }

        &__button {
            font-size: ${({ theme }) => theme.fontSizes.textTiny};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            cursor: pointer;
            text-transform: uppercase;
            background: ${({ theme }) => theme.colors.white};
            padding: ${rem(0)} ${rem(20)};
            height: ${rem(40)};
            display: flex;
            align-items: center;
            justify-content: center;

            @media (min-width: ${breakpoints.sm}px) {
                height: auto;
            }

            &:hover:enabled {
                color: ${({ theme }) => theme.colors.primary};
                border-color: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .isLoading {
        background: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.white};
    }
`;
